<app-modalpopup title="{{'_Shared_App_SignOut_Title_Text_' | translate }}">
  <app-signout></app-signout>
  <div mod-footer>
    <button type="button" class="btn btn-primary">{{'_Shared_App_SignOut_Title_Text_' | translate }}</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">{{'_General_Button_Cancel_Text_' | translate }}</button>
  </div>
</app-modalpopup>